import { BIModel } from './BIModel';

export class CommentCreatedBIModel extends BIModel {

    static eventName = 'comment_create';

    #productId;
    #productOwnerId;
    #isSeller;
    #timeSinceLastComment;
    #isFirstComment;
    #countrySeller;

    constructor(userId, productId, productOwnerId, isSeller, timeSinceLastComment, isFirstComment, countrySeller) {
        super(CommentCreatedBIModel.eventName, userId);
        this.#productId = productId;
        this.#productOwnerId = productOwnerId;
        this.#isSeller = isSeller;
        this.#timeSinceLastComment = timeSinceLastComment;
        this.#isFirstComment = isFirstComment;
        this.#countrySeller = countrySeller;
    }

    static createFromDomainEvent(userId, commentCreatedEvent) {
        return new CommentCreatedBIModel(
            commentCreatedEvent.userId,
            commentCreatedEvent.productId,
            commentCreatedEvent.productOwnerId,
            commentCreatedEvent.isSeller,
            commentCreatedEvent.timeSinceLastComment,
            commentCreatedEvent.isFirstComment,
            commentCreatedEvent.countrySeller
        );
    }

    get productId() {
        return this.#productId;
    }

    get productOwnerId() {
        return this.#productOwnerId;
    }

    get isSeller() {
        return this.#isSeller;
    }

    get timeSinceLastComment() {
        return this.#timeSinceLastComment;
    }

    get isFirstComment() {
        return this.#isFirstComment;
    }

    get modelData() {
        return {
            product_id: this.#productId,
            product_owner_id: this.#productOwnerId,
            is_seller: this.#isSeller,
            time_since_last_comment: this.#timeSinceLastComment,
            is_first_comment: this.#isFirstComment,
            country_seller: this.#countrySeller
        };
    }

}